import { render, staticRenderFns } from "./SideBarStrabane.vue?vue&type=template&id=1aea896f"
import script from "./SideBarStrabane.vue?vue&type=script&lang=js"
export * from "./SideBarStrabane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports